import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { DataUsageWarningComponent } from './data-usage-warning/data-usage-warning.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateRangeSectionComponent } from '../components/date-range-section/date-range-section.component';
import { FilterSectionComponent } from '../components/filter-section/filter-section.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { ReportTableComponent } from './report-table/report-table.component';
import { ReportToastContainerComponent } from './report-toast-container/report-toast-container.component';
import { ReportToastComponent } from './report-toast/report-toast.component';

@NgModule({
  declarations: [
    BreadcrumbComponent,
    DataUsageWarningComponent,
    DateRangeSectionComponent,
    FilterSectionComponent,
    ReportTableComponent,
    ReportToastContainerComponent,
    ReportToastComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    MatTableModule,
  ],
  exports: [
    BreadcrumbComponent,
    DataUsageWarningComponent,
    DateRangeSectionComponent,
    FilterSectionComponent,
    TranslateModule,
    ReportTableComponent,
    ReportToastContainerComponent,
    ReportToastComponent,
  ],
})
export class CustomerReportingComponentsSharedModule {}
